Element.prototype.setTranslateValue = function(x,y) {
    this.style.transform = "translate(" + x + "px, " + y + "px)";
};

class Carousel {
    static NEXT = "NEXT";
    static PREV = "PREV";

    initialOptions = {
        visible: 1,
        mobileVisible: 1,
        tabletVisible: 1,
        moveBy: 1,
        tabletMoveBy: 1,
        mobileMoveBy: 1,
        speed: 600,
        tabletSpeed: 600,
        mobileSpeed: 600,
        auto: true,
        pause: 8000,
        margin: 0
    };

    resizeFrame;
    resizeTimeout;
    touchFrame;
    onSlideListener;

    constructor(el, options = this.initialOptions) {
        this.originalVisible = options.visible;
        this.options = { ...this.initialOptions, ...options };
        this.sliding = 0;
        this.pause = 0;
        this.rail = el;
        this.items = this.rail.children;
        this.originalLength = this.items.length;
        this.wrapper = document.createElement('div');
        this.viewport = document.createElement('div');
        this.pagerContainer = document.createElement('div');
        this.pagerContainer.className = 'carousel-pager flex flex-row flex-row--absolute';
        this.dotsContainer = document.createElement('div');
        this.dotsContainer.className = 'carousel-dots flex flex-row flex-row--absolute';
        this.counter = document.createElement('span');
        this.currentIndex = 0;
        this.autoInterval = null;
        this.resizeFlag = 0;
        this.touching = 0;
        this.touchDown = 0;
        this.touchDownY = 0;
        this.touchMove = 0;

        this.wrapper.className = 'carousel-wrapper';
        this.viewport.className = 'carousel-viewport';
        this.rail.classList.add('carousel-rail');
        this.rail.classList.add('flex-row-absolute');

        this.wrapper.appendChild(this.viewport);
        this.rail.parentNode.insertBefore(this.wrapper, this.rail);
        this.viewport.appendChild(this.rail);

        this.setVisible();

        this.itemWidth = (this.wrapper.offsetWidth / this.options.visible) - this.options.margin;

        this.constructClones();
    }

    bindEvents() {
        if (this.options.auto) {
            this.initialiseAuto(true);
        }

        window.addEventListener('resize', () => {
            if (!this.resizeFlag) {
                this.resizeFrame = window.requestAnimationFrame(this.resizeHandler.bind(this));
            }

            this.resizeFlag = 1;
            clearTimeout(this.resizeTimeout);

            this.resizeTimeout = setTimeout(() => {
                this.resizeFlag = 0;
                cancelAnimationFrame(this.resizeFrame);
            }, 150);
        });

        this.viewport.addEventListener('touchstart', this.touchDownHandler.bind(this), { passive: true });
        this.viewport.addEventListener('mousedown', this.mouseDownHandler.bind(this));
        this.viewport.addEventListener('touchend', this.touchUpHandler.bind(this), { passive: true });
        this.viewport.addEventListener('mouseup', this.mouseUpHandler.bind(this));
        this.viewport.addEventListener('mouseleave', this.mouseUpHandler.bind(this));
        this.viewport.addEventListener('touchmove', this.touchMoveHandler.bind(this), { passive: true });
        this.viewport.addEventListener('mousemove', this.mouseMoveHandler.bind(this));

        document.addEventListener('keydown', this.keyHandler.bind(this));

        window.addEventListener('touchmove', e => {
            if (this.touching) {
                const yTouch = e.touches[0].clientY;
                const xTouch = e.touches[0].clientX;

                if (Math.abs(yTouch - this.touchDownY) < Math.abs(xTouch - this.touchDown)) {
                    e.preventDefault();
                }
            }
        }, { passive: false });
    }

    addOnSlideListener(onSlideListener) {
        this.onSlideListener = onSlideListener;
    }

    sizeRail() {
        const itemSize = (this.itemWidth + this.options.margin);
        this.rail.style.width = this.items.length * itemSize + "px";
        this.rail.setTranslateValue(-(this.originalLength * itemSize), 0);
        this.items[this.originalLength].setAttribute('aria-current', 'true');
        this.reconstructControls();
    }

    keyHandler(e) {
        const bounding = this.viewport.getBoundingClientRect();
        if (bounding.top >= 0 && bounding.bottom <= window.innerHeight) {
            if (e.key === 'ArrowLeft') {
                this.slide(Carousel.PREV, null, true);
            }
            if (e.key === 'ArrowRight') {
                this.slide(Carousel.NEXT, null, true);
            }
        }
    }

    setVisible() {
        if (this.originalVisible > 1) {
            if (window.innerWidth <= 660) this.options.visible = this.options.mobileVisible || 1;
            else if (window.innerWidth <= 920) this.options.visible = this.options.tabletVisible || 2;
            else this.options.visible = this.originalVisible;
        }
    }

    resizeHandler() {
        if (!this.resizeFlag) {
            this.resizeFrame = requestAnimationFrame(this.resizeHandler.bind(this));
            return;
        }

        this.setVisible();

        this.itemWidth = (this.wrapper.offsetWidth / this.options.visible) - this.options.margin;
        const itemArray = [].slice.call(this.items);

        for (const item of itemArray) {
            item.style.flex = "0 0 " + this.itemWidth + "px";
            item.style.width = this.itemWidth + "px";
            item.style.marginRight = this.options.margin * 0.5 + "px";
            item.style.marginLeft = this.options.margin * 0.5 + "px";
        }

        this.sizeRail();
        this.resizeFrame = requestAnimationFrame(this.resizeHandler.bind(this));
    }

    constructClones() {
        const prefixClones = [];
        const suffixClones = [];

        for (let i = 0; i < this.items.length; i++) {
            this.items[i].style.flex = '0 0 ' + this.itemWidth + 'px';
            this.items[i].style.width = this.itemWidth + 'px';
            this.items[i].style.marginRight = (this.options.margin * 0.5) + 'px';
            this.items[i].style.marginLeft = (this.options.margin * 0.5) + 'px';
            this.items[i].setAttribute('data-index', i.toString());
            prefixClones.push(this.items[i].cloneNode(true));
            suffixClones.push(this.items[i].cloneNode(true));
        }

        for (let i = (prefixClones.length - 1); i >= 0; i--) {
            prefixClones[i].setAttribute('data-clone', 'true');
            this.rail.insertBefore(prefixClones[i], this.rail.children[0]);
        }

        for (const clone of suffixClones) {
            clone.setAttribute('data-clone', 'true');
            this.rail.appendChild(clone);
        }

        this.sizeRail();
        this.setActiveDot();
    }

    constructArrows() {
        const arrowPrev = document.createElement('button');
        const arrowNext = document.createElement('button');

        arrowPrev.className = 'carousel-arrow carousel-arrow--prev';
        arrowPrev.title = 'Previous';
        arrowNext.className = 'carousel-arrow carousel-arrow--next';
        arrowNext.title = 'Next';

        arrowPrev.addEventListener('click', () => {
            this.slide(Carousel.PREV, null, true);
        });
        arrowNext.addEventListener('click', () => {
            this.slide(Carousel.NEXT, null, true);
        });

        this.pagerContainer.insertBefore(arrowPrev, this.pagerContainer.children[0]);
        this.pagerContainer.appendChild(arrowNext);
    }

    constructPager() {
        this.dotsContainer.innerHTML = null;

        for (let i = 0; i < this.originalLength / this.getMoveBy(); i++) {
            const dot = document.createElement('button');
            dot.setAttribute('data-index', i.toString());
            dot.addEventListener('click', () => {
                this.slide(null, i, true);
            });
            dot.title = 'Go to slide ' + (i + 1);
            dot.className = 'carousel-dot';

            if (i === 0) {
                dot.setAttribute('aria-current', 'true');
            }
            this.dotsContainer.appendChild(dot);
        }

        this.pagerContainer.appendChild(this.dotsContainer);
        this.wrapper.appendChild(this.pagerContainer);
    }

    constructCounter() {
        this.counter.className = 'carousel-counter mob-only';
        this.counter.innerHTML = "1 of " + this.originalLength / this.getMoveBy();
        this.pagerContainer.appendChild(this.counter);
    }

    reconstructControls() {
        this.pagerContainer.innerHTML = null;
        this.constructPager();
        this.constructArrows();
        this.constructCounter();
    }

    getSlideSpeed() {
        return window.innerWidth <= 660 ? this.options.mobileSpeed :
            window.innerWidth <= 920 ? this.options.tabletSpeed : this.options.speed;
    }

    getMoveBy() {
        return window.innerWidth <= 660 ? this.options.mobileMoveBy :
            window.innerWidth <= 920 ? this.options.tabletMoveBy : this.options.moveBy;
    }

    slide(direction, index = null, override = false) {
        if (!override && this.pause) return;
        if (this.sliding) return;

        const moveBy = this.getMoveBy();
        const speed = this.getSlideSpeed();

        clearInterval(this.autoInterval);
        const itemArray = [].slice.call(this.items);
        const itemSize = this.itemWidth + this.options.margin;

        if (direction !== null) {
            let amt = direction === Carousel.PREV ? itemSize : itemSize * -1;
            amt = amt * moveBy;

            for (const item of itemArray) {
                item.style.transition = "transform " + speed + "ms linear";
                item.setTranslateValue(amt, 0);
            }

            this.sliding = 1;

            setTimeout(() => {
                for (const item of itemArray) {
                    item.style.transition = "none";
                    item.setTranslateValue(0, 0);
                }

                if (direction === Carousel.PREV) {
                    this.currentIndex--;
                    if (this.currentIndex < 0) this.currentIndex = (this.originalLength / moveBy) - 1;
                    for (let i = itemArray.length - 1; i >= itemArray.length - (moveBy); i--) {
                        this.rail.insertBefore(this.rail.lastElementChild, this.rail.firstElementChild);
                    }
                } else {
                    this.currentIndex++;
                    if (this.currentIndex >= this.originalLength / moveBy) this.currentIndex = 0;

                    for (let i = 0; i < moveBy; i++) {
                        this.rail.appendChild(this.rail.firstElementChild);
                    }
                }

                this.sliding = 0;
                this.setActiveDot();
                this.initialiseAuto();
            }, speed);
            return;
        }

        if (index !== null) {
            const difference = this.currentIndex - index;
            const amt = difference * this.itemWidth;

            for (const item of itemArray) {
                item.style.transition = "transform " + speed + "ms linear";
                item.setTranslateValue(amt, 0);
            }

            this.currentIndex = Math.abs(this.currentIndex - difference);

            setTimeout(() => {
                for (const item of itemArray) {
                    item.style.transition = "none";
                    item.setTranslateValue(0, 0);
                }

                for (let i = 0; i < Math.abs(difference); i++) {
                    if (difference > 0) {
                        this.rail.insertBefore(this.rail.lastElementChild, this.rail.firstElementChild);
                    } else {
                        this.rail.appendChild(this.rail.firstElementChild);
                    }
                }

                this.setActiveDot();
                this.initialiseAuto();
            }, speed);
        }
    }

    setActiveDot() {
        const dotArray = [].slice.call(this.dotsContainer.children);

        for (const dot of dotArray) {
            const index = parseInt(dot.dataset.index);
            dot.setAttribute('aria-current', index === this.currentIndex);
        }


        const moveBy = this.getMoveBy();
        const startingPoint = ((this.items.length / moveBy)  / 3);
        const itemsArray = [].slice.call(this.items);

        for (let i = 0; i < itemsArray.length; i++) {
            itemsArray[i].setAttribute('aria-current', i === startingPoint);
        }

        this.counter.innerHTML = (this.currentIndex + 1) + " of " + (this.originalLength / this.getMoveBy());
        if (this.onSlideListener) this.onSlideListener(this.currentIndex);
    }

    initialiseAuto(initial = false) {
        this.autoInterval = setInterval(() => {
            const bounds = this.wrapper.getBoundingClientRect();

            if (bounds.top < window.innerHeight && bounds.top > 0 &&
                bounds.bottom < window.innerHeight && bounds.bottom > 0) {
                this.slide(Carousel.NEXT, null, false);
            }
        }, this.options.pause);

        if (initial) {
            this.wrapper.addEventListener('mouseover', () => {
                this.pause = 1;
            });
            this.wrapper.addEventListener('mouseleave', () => {
                this.pause = 0;
            });
        }
    }

    touchDownHandler(e) {
        e.stopPropagation();
        this.pause = 1;
        this.touching = 1;
        this.touchDown = e.touches[0].clientX;
        this.touchDownY = e.touches[0].clientY;
        this.touchFrame = requestAnimationFrame(this.touchFrameHandler.bind(this));
    }

    mouseDownHandler(e) {
        this.pause = 1;
        this.touching = 1;
        this.touchDown = e.clientX;
        this.wrapper.setAttribute('data-grabbing', 'true');
        this.touchFrame = requestAnimationFrame(this.touchFrameHandler.bind(this));
    }

    touchUpHandler() {
        this.pause = 0;
        this.touching = 0;
        this.touchDown = 0;
        this.touchMove = 0;
        this.returnPosition();
        cancelAnimationFrame(this.touchFrame);
    }

    mouseUpHandler() {
        this.pause = 0;
        this.touching = 0;
        this.touchDown = 0;
        this.touchMove = 0;

        setTimeout(() => {
            this.wrapper.setAttribute('data-grabbing', 'false');
        }, 400);

        this.returnPosition();
        cancelAnimationFrame(this.touchFrame);
    }

    returnPosition() {
        if (!this.sliding) {
            const itemArray = [].slice.call(this.items);

            for (const item of itemArray) {
                item.style.transition = "transform 400ms linear";
                item.setTranslateValue(0, 0);
            }

            setTimeout(() => {
                for (const item of itemArray) {
                    item.style.transition = "none";
                }
            }, 400);
        }
    }

    touchMoveHandler(e) {
        this.touchMove = e.touches[0].clientX;
    }

    mouseMoveHandler(e) {
        this.touchMove = e.clientX;
    }

    touchFrameHandler() {
        if (!this.touching || this.touchMove <= 0) {
            this.touchFrame = requestAnimationFrame(this.touchFrameHandler.bind(this));
            return;
        }

        const amt = this.touchDown - this.touchMove;
        const itemArray = [].slice.call(this.items);

        for (const item of itemArray) {
            item.setTranslateValue((amt * -1), 0);
        }

        // Massively unnecessary bit shift FOR TOP SPEED NEEEEEOOOWWWWWWWWWWWMMM
        if (Math.abs(amt) > this.viewport.offsetWidth >> 2) {
            const direction = amt < 0 ? Carousel.PREV : Carousel.NEXT;

            this.slide(direction, null, true);
            this.mouseUpHandler();
            this.touchUpHandler();
            return;
        }

        this.touchFrame = requestAnimationFrame(this.touchFrameHandler.bind(this));
    }
}

const getCarouselOptions = (el) => {
    return {
        visible: el.hasAttribute('data-visible') &&
            parseInt(el.getAttribute('data-visible')) || 1,
        tabletVisible: el.hasAttribute('data-tablet-visible') &&
            parseInt(el.getAttribute('data-tablet-visible')) || 1,
        mobileVisible: el.hasAttribute('data-mobile-visible') &&
            parseInt(el.getAttribute('data-mobile-visible')) || 1,
        moveBy: el.hasAttribute('data-move-by') &&
            parseInt(el.getAttribute('data-move-by')) || 1,
        tabletMoveBy: el.hasAttribute('data-tablet-move-by') &&
            parseInt(el.getAttribute('data-tablet-move-by')) || 1,
        mobileMoveBy: el.hasAttribute('data-mobile-move-by') &&
            parseInt(el.getAttribute('data-mobile-move-by')) || 1,
        auto: !(el.hasAttribute('data-auto') &&
            el.getAttribute('data-auto') === 'false'),
        pause: el.hasAttribute('data-pause') &&
            parseInt(el.getAttribute('data-pause')) || 8000,
        margin: el.hasAttribute('data-margin') &&
            parseInt(el.getAttribute('data-margin')) || 0,
        speed: el.hasAttribute('data-speed') &&
            parseInt(el.getAttribute('data-speed')) || 600,
        tabletSpeed: el.hasAttribute('data-tablet-speed') &&
            parseInt(el.getAttribute('data-tablet-speed')) || 600,
        mobileSpeed: el.hasAttribute('data-mobile-speed') &&
            parseInt(el.getAttribute('data-mobile-speed')) || 600
    }
}

const setupInitialCarousels = () => {
    const carouselDiv = document.querySelectorAll('[data-plugin-carousel]');
    for (let i = 0; i < carouselDiv.length; i++) {
        const carousel = new Carousel(
            carouselDiv[i],
            getCarouselOptions(carouselDiv[i])
        );

        carousel.bindEvents();
    }
}

// Make function available globally
window.setupInitialCarousels = setupInitialCarousels;